import {
    type GetAwayAvailability,
    GetAwayAvailabilityMinified,
    GetAwayRate,
    type GetAwayRateDTOMinified,
    GetAwayRateMinified
  } from './GetAwayAvailability'

import { generateV4UUID, objectToBase64, objectFromBase64 } from '~/core/ts/util/string'

export type GetAwayPrePurchaseDTO = {
  uuid: string,
  uuid_revision: string,
  package_availability: {
    package_uuid: string,
    package_uuid_revision: string,
    from: number,
    to: number,
    num_pax: number,
    rates: Array<GetAwayRateDTOMinified>,
  },
  lang_code: string,
}

export class GetAwayPrePurchase {
  constructor(
    public uuid: string,
    public uuidRevision: string,
    public availability: GetAwayAvailabilityMinified,
    public selectedRate: GetAwayRateMinified,
    public langCode: string,
  ) { }

  static create(availability: GetAwayAvailability, selectedRate: GetAwayRate, langCode: string): GetAwayPrePurchase {
    const uuid = generateV4UUID()
    const uuidRevision = generateV4UUID()

    const miniAvailability = GetAwayAvailabilityMinified.from(availability)

    const miniSelectedRate = GetAwayRateMinified.from(selectedRate)

    return new GetAwayPrePurchase(
      uuid,
      uuidRevision,
      miniAvailability,
      miniSelectedRate,
      langCode,
    )
  }

  /**
   * @param encoded Base64
   * @returns GetAwayPrePurchase
   */
  static fromEncoded(encoded: string): GetAwayPrePurchase {
    const clean = decodeURI(encoded)
    return objectFromBase64(clean) as GetAwayPrePurchase
  }

  static to(prePurchase: GetAwayPrePurchase): GetAwayPrePurchaseDTO {
    const rates = [ GetAwayRateMinified.to(prePurchase.selectedRate) ]

    return {
      uuid: prePurchase.uuid,
      uuid_revision: prePurchase.uuidRevision,
      package_availability: {
        package_uuid: prePurchase.availability.packageUuid,
        package_uuid_revision: prePurchase.availability.packageUuidRevision,
        from: prePurchase.availability.from,
        to: prePurchase.availability.to,
        num_pax: prePurchase.availability.numPax,
        rates,
      },
      lang_code: prePurchase.langCode,
    }
  }

  /**
   * @param prePurchase
   * @returns Base64
   */
  static toEncoded(prePurchase: GetAwayPrePurchase): string {
    return objectToBase64(prePurchase)
  }
}
